import { Article, DynamicFeed, ViewQuilt } from '@mui/icons-material';
import { DesignCreationType } from 'src/services/DesignConductorService';

export const getDesignTypeIcon = (type: DesignCreationType): JSX.Element => {
    switch (type) {
        case 'Static':
            return <Article fontSize="small" />;
        case 'Dynamic':
            return <DynamicFeed fontSize="small" />;
        case 'AutoLayout':
            return <ViewQuilt fontSize="small" />;
        default:
            return <Article fontSize="small" />;
    }
};

export const getDesignTypeColor = (type: DesignCreationType): 'primary' | 'success' | 'secondary' => {
    switch (type) {
        case 'Static':
            return 'primary'; // blue
        case 'Dynamic':
            return 'success'; // green
        case 'AutoLayout':
            return 'secondary'; // purple
        default:
            return 'primary';
    }
};

// For custom purple color when not using Chip color prop
export const getDesignTypeCustomColor = (type: DesignCreationType): string | undefined => {
    switch (type) {
        case 'AutoLayout':
            return '#9c27b0'; // Material-UI purple
        default:
            return undefined;
    }
};
